import { render, staticRenderFns } from "./checkout2.vue?vue&type=template&id=177d1a9d&scoped=true&"
import script from "./checkout2.vue?vue&type=script&lang=js&"
export * from "./checkout2.vue?vue&type=script&lang=js&"
import style0 from "./checkout2.vue?vue&type=style&index=0&id=177d1a9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d1a9d",
  null
  
)

export default component.exports